import { motion } from "framer-motion";
import { useMatch } from "@/match/MatchContext";
import { CommentaryButton } from "./StorySection";

// FULL TIME — the main match ends; the shootout looms.
export default function FullTime() {
  const { scrollTo, startShootout, openCommentary } = useMatch();

  return (
    <div
      className="relative bg-[#0A0A0A] border-b-4 border-black py-24 sm:py-32 px-4 sm:px-8 lg:px-16 overflow-hidden"
      data-testid="fulltime-section"
    >
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to right, #84E116 0, #84E116 140px, transparent 140px, transparent 280px)",
        }}
        aria-hidden="true"
      />
      <div className="relative max-w-4xl mx-auto text-center">
        <motion.span
          className="inline-block bg-[#84E116] text-black font-broadcast font-extrabold text-[10px] sm:text-xs tracking-[0.3em] uppercase px-4 py-2 mb-8"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
        >
          90:00 · The whistle blows
        </motion.span>
        <motion.h2
          className="font-display uppercase text-6xl sm:text-8xl lg:text-9xl leading-[0.85] tracking-tight text-white mb-8"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
          data-testid="fulltime-title"
        >
          Full <span className="text-[#84E116]">Time</span>
        </motion.h2>
        <motion.p
          className="text-base sm:text-lg font-medium leading-relaxed text-white/75 max-w-xl mx-auto mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          College is ending. Decisions about work, money, and the future can't wait
          any longer. I don't have every answer — but the game isn't done asking
          questions.
        </motion.p>
        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-5"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.55, delay: 0.18 }}
        >
          <CommentaryButton
            onClick={() => openCommentary("fulltime")}
            testId="fulltime-commentary-btn"
          />
          <button
            type="button"
            onClick={() => {
              startShootout();
              scrollTo("#shootout");
            }}
            data-testid="enter-shootout-btn"
            className="font-display uppercase text-lg sm:text-xl tracking-wide bg-[#84E116] text-black border-[3px] border-black hard-shadow-white px-10 py-4 transition-all duration-200 hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[8px_8px_0_0_rgba(255,255,255,0.9)] active:translate-x-1 active:translate-y-1 active:shadow-none"
          >
            Face The Penalties
          </button>
        </motion.div>
      </div>
    </div>
  );
}
